export default __webpack_public_path__ + "static/media/4-shine.6684d77e.png";